<template>
  <div>
    <md-card class="card-container">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="isEditing ? '修改營業地點' : '新增營業地點'"></page-title>
        </div>
      </div>
      <div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>名稱</label>
              <md-input v-model="data.name"></md-input>
            </md-field>
          </div>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised md-danger" @click="goItemList">返回</md-button>
          <md-button class="md-raised md-accent" @click="removeItem">刪除營業地點</md-button>
        </div>
        <div class="md-layout-item">
          <md-button class="float-right md-raised md-primary" @click="submit">送出</md-button>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import axios from 'axios'
import urls from '@/urls'

export default {
  data () {
    return {
      isEditing: null,
      data: {
        name: null
      }
    }
  },
  components: {
    PageTitle
  },
  created: function () {
    if (this.$route.params.id !== 'add') {
      this.isEditing = this.$route.params.id
      this.readItem(this.isEditing)
    }
  },
  methods: {
    goItemList () {
      this.$router.push('/clinic')
    },
    submit: async function () {
      let url
      if (this.isEditing) {
        url = urls({route: 'clinic', id: this.isEditing})
        await axios.put(url, this.data)
      } else {
        url = urls({route: 'clinic'})
        await axios.post(url, this.data)
      }
      this.goItemList()
    },
    removeItem: async function () {
      await axios.delete(urls({route: 'clinic', id: this.isEditing}))
      this.goItemList()
    },
    readItem: async function (itemID) {
      let req = await axios.get(urls({route: 'clinic', id: this.isEditing}))
      this.data = req.data.data
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Clinic/ClinicEdit.vue